import { baseQuery, commonApi } from '@common/utils/baseQuery';
import { ICampaign, IInbetSession, IKenoCampaign, IKenoParticipants } from '@features/keno/api/kenoApi.type';
import { hasErrorStatus } from '@features/tournaments/lib/tournaments';
import config from '../../../config/config';

const MISSING_PAGE = [ 403, 404 ];

export const kenoApi = commonApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchCampaign: builder.query<ICampaign, void>({
      query: () => '/campaigns',
    }),
    fetchKenoCampaign: builder.query<IKenoCampaign, void>({
      query: () => '/kenocampaign',
    }),
    fetchKenoCampaignDetails: builder.query<string, { id: number, lang: string }>({
      async queryFn({ id, lang }, api) {
        const anonymous = { ...api, extra: { useToken: false } };
        const load = (language: string) => baseQuery({
          url: `${config.cdn}/kenocampaigns/${language}/${id}.html`,
          responseHandler: (response) => response.text(),
        }, anonymous, {});
        let page = await load(lang);
        if (page.error && lang !== 'ru' && hasErrorStatus(page.error, MISSING_PAGE)) {
          page = await load('ru');
        }
        if (page.error) {
          return { error: page.error };
        }
        return { data: typeof page.data === 'string' ? page.data : '' };
      },
    }),
    fetchKenoParticipants: builder.query<IKenoParticipants[], void>({
      query: () => '/kenocampaign/top',
    }),
    fetchInbetSession: builder.query<IInbetSession, void>({
      query: () => '/inbet/sessions',
    }),
  }),
});

export const {
  useFetchCampaignQuery,
  useFetchKenoCampaignQuery,
  useFetchKenoCampaignDetailsQuery,
  useFetchKenoParticipantsQuery,
  useFetchInbetSessionQuery,
} = kenoApi;
